import IconCancel from '@bimser/icons/16/cancel';
import IconOk from '@bimser/icons/16/ok';

const checkBoxDisplayCell = props => (props.data.value ? <IconOk /> : <IconCancel />);
export { checkBoxDisplayCell };
